import { render, staticRenderFns } from "./Agent.vue?vue&type=template&id=08fed8e8&scoped=true&"
import script from "./Agent.vue?vue&type=script&lang=js&"
export * from "./Agent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fed8e8",
  null
  
)

export default component.exports